export const SplashScreen = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-100">
      <img
        src={`${process.env.PUBLIC_URL}/DTS_splash.svg`}
        alt="splashIcon"
        width={"75%"}
        height={"75%"}
      />
    </div>
  );
};
